import useOperation from './use-operation'

export default function useModelKeyName () {
  const operation = useOperation()

  if (!operation || !operation.modelKey) {
    return null
  }

  return operation.modelKey
}
